import { styled, Box, Stack, Grid } from '../../../../base';

export const StyledBarViewWrapper = styled(Stack)(({ theme }) => ({
    padding: theme.spacing(2, 3),
    gap: theme.spacing(2),
}));

export const StyledToolbarRow = styled(Grid)(({ theme }) => ({
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
}));

export const StyledDropdownSlot = styled(Box)({
    flex: '0 1 220px',
    minWidth: 160,
});

export const StyledToolbarSpacer = styled(Box)({
    flex: 1,
});

export const StyledBarCard = styled(Stack)(({ theme }) => ({
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 16,
}));

export const StyledBarCardHeader = styled(Grid)(({ theme }) => ({
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    padding: theme.spacing(2),
}));

export const StyledBarCardBody = styled(Box)(({ theme }) => ({
    padding: theme.spacing(1, 2, 3),
}));

export const StyledBarEmptyState = styled(Stack)(({ theme }) => ({
    width: '100%',
    minHeight: 300,
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(4, 2),
}));
